function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 16 16",
    preserveAspectRatio: "none",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4.4 4.35 11.895a1.173 1.173 0 0 1-1.903.032L.4 9.198",
    style: {
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "transparent"
    },
    vectorEffect: "non-scaling-stroke",
    transform: "translate(1.6 1.6)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck1);
export default __webpack_public_path__ + "static/media/check-1.fdecaea3df1a4ce54985cba1a7e74da9.svg";
export { ForwardRef as ReactComponent };